import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { NavigationTypes } from "web_myplann/Utils/WebViewModel";

export const handleNavigationRequest = (
	url: string | undefined,
	navigate: (path: string) => void,
) => {
	switch (url) {
		case NavigationTypes.WebDashboard:
			navigate(Routing.Dashboard.path());
			break;
		case NavigationTypes.WebPortfolio:
			navigate(Routing.Portfolio.PortfolioTabs.path());
			break;
		case NavigationTypes.WebActivity:
			navigate(Routing.ActivitiesList.path());
			break;
		case NavigationTypes.WebAdvisor:
			navigate(Routing.Advisor.path());
			break;
		case NavigationTypes.GoalsScreen:
			navigate(Routing.Goals.GoalsList.path());
			break;
		case NavigationTypes.MoreScreen:
			navigate(Routing.Profile.More.path());
			break;
	}
};
